export default __webpack_public_path__ + "static/media/Cynthia.4314ab2f.jpeg";